import * as Sentry from "@sentry/react";
import { SearchParamError } from "@tanstack/react-router";
import { isNetworkError } from "@/api/error";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_STAGE,
  integrations: [],
  ignoreErrors: ["releasePointerCapture", "Object Not Found Matching Id"],
  beforeSend: (event, hint) => {
    if (isNetworkError(hint.originalException)) {
      event.fingerprint = ["network-failure"];
    } else if (hint.originalException instanceof SearchParamError) {
      event.fingerprint = ["search-param-error", hint.originalException.message];
    }
    return event;
  },
});
